import { Game, selectGameIsUnderMaintenance } from '@bonanza-social/games';
import { memo } from 'react';
import { useTranslation } from '@bonanza-social/i18n';
import { Box, Text } from '@bonanza-social/moonlight';
import { State, useSelector } from '@bonanza-social/toolkit/state';

function FreeSpinGame({ id, spinsLeft }: { id: number; spinsLeft?: number }) {
  const { t } = useTranslation('rewards');

  const isUnderMaintenance = useSelector((state: State) =>
    selectGameIsUnderMaintenance(state, id),
  );

  return (
    <Box testID={`free-spin-game-${id}`}>
      <Game id={id} imageType="square" zIndex={2} />
      <Box zIndex={1}>
        {isUnderMaintenance ? (
          <Box
            variant="gradient"
            gradient="fullOverlayBackground"
            position="absolute"
            top="-space-500"
            left="space-0"
            right="space-0"
            bottom="space-0"
            borderRadius="radius-400"
            height="155%"
            zIndex={2}
          />
        ) : null}
        <Box
          backgroundColor="accentSolidBackground"
          width="50%"
          height={50}
          position="absolute"
          bottom="space-400"
          left="space-0"
          zIndex={1}
        />
        <Box
          variant="gradient"
          gradient="accentBackground"
          paddingHorizontal="space-300"
          paddingVertical="space-200"
          borderRadius="radius-400"
          zIndex={1}
        >
          <Text variant="body-m" textAlign="center">
            {t('spinsWithCount', { count: spinsLeft })}
          </Text>
        </Box>
      </Box>
    </Box>
  );
}

export default memo(FreeSpinGame);
